/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHealthcareFacilityDto } from './GetHealthcareFacilityDto';
import {
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoFromJSONTyped,
    GetHealthcareFacilityDtoToJSON,
} from './GetHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetFiscalPrinterLocationDto
 */
export interface GetFiscalPrinterLocationDto {
    /**
     * 
     * @type {string}
     * @memberof GetFiscalPrinterLocationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFiscalPrinterLocationDto
     */
    printerUid?: string | null;
    /**
     * 
     * @type {GetHealthcareFacilityDto}
     * @memberof GetFiscalPrinterLocationDto
     */
    healthcareFacility?: GetHealthcareFacilityDto | null;
}

/**
 * Check if a given object implements the GetFiscalPrinterLocationDto interface.
 */
export function instanceOfGetFiscalPrinterLocationDto(value: object): value is GetFiscalPrinterLocationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetFiscalPrinterLocationDtoFromJSON(json: any): GetFiscalPrinterLocationDto {
    return GetFiscalPrinterLocationDtoFromJSONTyped(json, false);
}

export function GetFiscalPrinterLocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFiscalPrinterLocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'printerUid': json['printerUid'] == null ? undefined : json['printerUid'],
        'healthcareFacility': json['healthcareFacility'] == null ? undefined : GetHealthcareFacilityDtoFromJSON(json['healthcareFacility']),
    };
}

export function GetFiscalPrinterLocationDtoToJSON(value?: GetFiscalPrinterLocationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'printerUid': value['printerUid'],
        'healthcareFacility': GetHealthcareFacilityDtoToJSON(value['healthcareFacility']),
    };
}

